import { render, staticRenderFns } from "./Cursante.vue?vue&type=template&id=457db192&"
import script from "./Cursante.vue?vue&type=script&lang=js&"
export * from "./Cursante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports